import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieManagementService } from 'src/app/account/services/cookie-management.service';
import { AppConfig } from 'src/app/config-service/app.config';
import { VersionHelper } from 'src/app/utility-packages/versionHelper/version-helper';
import { GetDefinedCardServiceResModel } from '../../models/get-defined-card-models';

@Injectable({
  providedIn: 'root'
})
export class GetDefinedCardService {

  constructor(
    private http: HttpClient,
    private cookieManagementService: CookieManagementService,
    private versionHelper: VersionHelper
  ) { }

  private setParams = () : HttpParams => {
    let params = new HttpParams()
      .set('payment_type', '15')
      .set('region', AppConfig.settings.city.region)
      .set('authType', AppConfig.settings.apiServer.authType)
      .set('version', this.versionHelper.getVersion())
      .set('lang', AppConfig.settings.apiServer.lang);
  
    return params;
  }

  private setHeaders = (accessToken:string) : HttpHeaders => {
    accessToken = 'Bearer ' + accessToken;

    return new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      authorization: accessToken,
    });
  }

  getDefinedCard = () : Observable<GetDefinedCardServiceResModel>=> {
    const accessToken = this.cookieManagementService.getAccessToken();
    if(!accessToken){
      return  new Observable();
    }else{
      const headers:HttpHeaders = this.setHeaders(accessToken);
      const params:HttpParams = this.setParams();

      return this.http.get<GetDefinedCardServiceResModel>(
        AppConfig.settings.apiServer.url + "api/account/ccard",
        {
          headers: headers,
          params: params
        }
      )

    }
  }

}